import React from 'react'

const CalendarSelect = ({name, values, chosenDate}) => {

    return (
        <button
            type='button'
            className="calendar-button"
            value={values[name]}>
            {
                chosenDate
                ? <div>{chosenDate}</div>
                : <div className="headerTitle big">Due date</div>
            }
        </button>
    )
}

export default CalendarSelect